import { Trans, useTranslation } from 'react-i18next';

import { Icons, IconType } from '../../../constants/icons';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './AboutCashCreditPopup.module.css';

type AboutCashCreditPopupProps = {
  onPrimary: () => void;
};

export const AboutCashCreditPopup = (props: AboutCashCreditPopupProps) => {
  const { onPrimary } = props;

  const { t } = useTranslation();

  return (
    <BasicPopupContainer onPrimaryButtonClick={onPrimary}>
      <div className={styles.popupContent}>
        <img src={Icons[IconType.Credit]} className={styles.cashIcon} />
        <div className={styles.title}>{t('About Cash Credit')}</div>

        <div className={styles.description}>
          {t(
            'Cash Credit can be spent to reduce the price of your future JOYAJOY product purchases.',
          )}
        </div>

        {/* <div className={styles.content}> */}
        <ul className={styles.list}>
          <li className={styles.listItem}>
            <Trans i18nKey="About Cash Credit Available Reward">
              <span className={styles.boldText}>Available Reward</span>
              is the amount of Cash Credit that can be can be spent to reduce
              the price of your future JOYAJOY product purchases.
            </Trans>
          </li>
          <li className={styles.listItem}>
            <Trans i18nKey="About Cash Credit Confirmed Reward">
              <span className={styles.boldText}>Confirmed Reward</span>
              is the total reward amount earned from actual purchases made by
              your referred users. Once your referred users complete their
              purchases, the Confirmed Reward will become Available Reward after
              one month.
            </Trans>
          </li>
        </ul>
        {/* </div> */}
      </div>
    </BasicPopupContainer>
  );
};
